// extracted by mini-css-extract-plugin
export var scrollArea = "_ms-0";